import { PricingProduct } from '../../../../../../store/features/products/types';
import { useProductPricing } from '../../../../../../hooks/selectPackage/useProductPricing';
import SecondLevelCard from '../../shared/SecondLevelCard';
import Typography from '../../../../../../shared/library/Typography';
import PriceInfo from '../../../../../../shared/components/PriceInfo';
import ProductDiscounts from '../../shared/ProductDiscounts';
import ProductTooltipInfoIcon from '../../shared/TooltipInfoIcon';
import TitleWithInlineElement from '../../shared/TitleWithInlineElement';
import VatMessage from '../../shared/VatMessage';

export interface SecondaryProductCardProps {
  product: PricingProduct;
}

export default function SecondaryProductCard(props: SecondaryProductCardProps) {
  const { product } = props;
  const { finalPrice, initialPrice, tieredSavingEndDate, vatValue, discounts } =
    useProductPricing(product);

  return (
    <SecondLevelCard
      date={
        <Typography
          variant="caption1"
          neutralColorIndex={700}
          opacity={0.7}
          className="informa-payment-secondary-product-card__date"
        >
          {product.productDate}
        </Typography>
      }
      title={
        <TitleWithInlineElement
          variant="featuredText"
          title={product.name}
          className="informa-payment-secondary-product-card__title"
        >
          {product.tooltipText && (
            <ProductTooltipInfoIcon text={product.tooltipText} />
          )}
        </TitleWithInlineElement>
      }
      price={
        <PriceInfo
          price={finalPrice}
          startPrice={initialPrice}
          discountDetails={
            <ProductDiscounts
              name={product.name}
              finalPrice={finalPrice}
              initialPrice={initialPrice}
              discounts={discounts}
              tieredSavingEndDate={tieredSavingEndDate}
              vat={<VatMessage vatAmount={vatValue} />}
            />
          }
          vat={<VatMessage vatAmount={vatValue} shortFormat />}
          variant="featuredText"
          className="informa-payment-secondary-product-card__price"
        />
      }
      className="informa-payment-secondary-product-card"
    />
  );
}
